module.exports = __webpack_public_path__ + "static/media/peer_image3.cde05beb.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/peer_image3.png
// module id = 2650
// module chunks = 0